import script from "./HowItWorksView.vue?vue&type=script&setup=true&lang=ts"
export * from "./HowItWorksView.vue?vue&type=script&setup=true&lang=ts"

import "./HowItWorksView.vue?vue&type=style&index=0&id=753debfd&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-753debfd"]])

export default __exports__